import {daUtils} from '../_utils';
import {IApiResponse, IDatasourceRequest, IItemIdRequest, IItemIdsRequest, ILicensee, IMuiDataRequest} from "./types";
import {API_PAF_BASE_URI} from "./index";

const API_LICENSEE_GET =`${API_PAF_BASE_URI}/licensees/filter/`;
const API_LICENSEE_GET_BY_ID =`${API_PAF_BASE_URI}/licensees/{licensee_id}/`;
const API_LICENSEE_ADD =`${API_PAF_BASE_URI}/licensees/`;
const API_LICENSEE_UPD =`${API_PAF_BASE_URI}/licensees/{licensee_id}/`;
const API_LICENSEE_DEL =`${API_PAF_BASE_URI}/licensees/delete/`;
const API_LICENSEE_DETAILS = `${API_PAF_BASE_URI}/licensees/default/`;

const get = async (
    options: IMuiDataRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LICENSEE_GET;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_id = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'GET',
        };
        const id = options.id.toString();
        const url = API_LICENSEE_GET_BY_ID.replace('{licensee_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}


const add = async (
    options: ILicensee,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_LICENSEE_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}


const update = async (
    options: ILicensee,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'PUT',
            body: JSON.stringify(options)
        };
        const id = options.licensee_id!.toString();
        const url = API_LICENSEE_UPD.replace('{licensee_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_LICENSEE_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}
const get_licensee_details = async (
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
        };
        const url = API_LICENSEE_DETAILS;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);
        return resp;
    } catch (error: any) {
        throw error;
    }
};
export const licenseeApi = {
    get,
    get_by_id,
    add,
    update,
    remove,
    get_licensee_details,
};